import React, { Component } from "react";
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';

const MobileMenu = ({ context }) => {
    
    const ctxMenu 	= () => context.menu;
	const menu 		= ctxMenu();
  	
  	function handleClick(evt) {
	  	evt.preventDefault();
	  	if (menu.interactive === true) {
	  		context.setMobilePanel(parseFloat(evt.target.getAttribute('data-index')));
	  	}
  	}
  	
  	if (menu.json.menu !== null) {
		const items = [];
    	for (let i=0;i<menu.json.menu.length;i++) {
	    	let itemClass = "c-mobile-menu__link";
	    	if (menu.json.menu[i].subitems) {
		    	itemClass = "c-mobile-menu__link c-mobile-menu__link--sub-items";
		    	items.push(<li className="c-mobile-menu__item" data-index={i} key={i}><Link to={{ pathname: menu.json.menu[i].url }} className={ itemClass } onClick={handleClick} data-index={i}>{ menu.json.menu[i].title }</Link></li>);	
		    } else {
			    items.push(<li className="c-mobile-menu__item" data-index={i} key={i}><Link to={{ pathname: menu.json.menu[i].url }} className={ itemClass }>{ menu.json.menu[i].title }</Link></li>);	
		    }
			
		}
		const panels = [];
		let count = 0;
		let _currentViewClass = '';
		for (let i=0;i<menu.json.menu.length;i++) {
			if (menu.json.menu[i].subitems) {
				let subitems = [];
				for (let j=0;j<menu.json.menu[i].subitems.length;j++) {
					subitems.push(<li className="c-mobile-menu__panel__item" key={count}><Link to={{ pathname: menu.json.menu[i].subitems[j].url }} className="c-mobile-menu__link" >{menu.json.menu[i].subitems[j].title}</Link></li>);
					count = count + 1;
				}
				
				if (i === menu.mobilePanel) {
					_currentViewClass = 'state-current-view';
				} else {
					_currentViewClass = '';
				}
				panels.push(
					<div key={i} className={'c-mobile-menu__panel c-mobile-menu__panel--secondary ' + _currentViewClass}>
						<ul className="c-mobile-menu__list">
							{subitems}
						</ul>
					</div>
				);
			}
		}
		if (-1 === menu.mobilePanel) {
			_currentViewClass = 'state-current-view';
		} else {
			_currentViewClass = '';
		}	
	    	
    	return (
    		<div className={`c-mobile-menu ${menu.mobileOpen ? "state-menu-open" : ""}`}>
    			<div className={'c-mobile-menu__panel ' + _currentViewClass}>
	    			<ul className="c-mobile-menu__list">
	    				{ items }
	    			</ul>
	    		</div>
    			{ panels }
    		</div>
    	)
	} else {
		return null;
	}
}
export default WithConsumer(MobileMenu);